import { AisProduct } from "src/app/shared/enums/AisProducts";
import { Temporality } from "./temporality";
import { NotamType } from "src/app/shared/enums/NotamTypes";
import { AiracType } from "src/app/shared/enums/AiracTypes";

/**
 * DTO for creating a new Update Notice.
 *
 */

export class CreateUpdateNoticeDTO {
  name: string = "";
  effectiveDate: Date = new Date();
  cancelDate: Date | null = null;
  temporality: string = Temporality.PERMANENT;
  description: string = "";
  aisProduct?: string = AisProduct.AMDT;
  airacType?: string = AiracType.AIRAC;
  // NOTAM related fields
  estimated?: boolean = false;
  notamType?: string = NotamType.N; // The values for this fields are N, R, C
  referredSeries?: string = "";
  referredNumber?: number = 0;
  referredYear?: number = 0;
  notamText?: string = "";
  firAerodromeAirfield?: string = "";
  lowerLimit?: string = "";
  upperLimit?: string = "";
  // AMDT related fields
  sectionsToBeAmended?: string = "";
  paragraphToBeAmended?: string = "";
  textToBeAmended?: string = "";

  constructor(init?: Partial<CreateUpdateNoticeDTO>) {
    Object.assign(this, init);
  }

  static parse(data: Partial<CreateUpdateNoticeDTO>): CreateUpdateNoticeDTO {
    const parsed = new CreateUpdateNoticeDTO();
    parsed.name = data.name;
    parsed.effectiveDate = data.effectiveDate;
    parsed.temporality = data.temporality?.[0];
    parsed.cancelDate = parsed.temporality === Temporality.TEMPORARY ? data.cancelDate : null;
    parsed.description = data.description;
    parsed.aisProduct = data.aisProduct;
    parsed.airacType = [AisProduct.AMDT, AisProduct.SUP].includes(parsed.aisProduct as AisProduct)
      ? data.airacType?.[0]
      : null;
    parsed.estimated = data.estimated;
    parsed.notamType = parsed.aisProduct === AisProduct.NOTAM ? data.notamType?.[0] : null;
    parsed.referredSeries = data.referredSeries;
    parsed.referredNumber = data.referredNumber;
    parsed.referredYear = data.referredYear;
    parsed.notamText = data.notamText;
    parsed.firAerodromeAirfield = data.firAerodromeAirfield;
    parsed.lowerLimit = data.lowerLimit;
    parsed.upperLimit = data.upperLimit;
    parsed.sectionsToBeAmended = data.sectionsToBeAmended;
    parsed.paragraphToBeAmended = data.paragraphToBeAmended;
    parsed.textToBeAmended = data.textToBeAmended;
    return parsed;
  }
}
